<template>
    <div class="ml-3 mr-3">
        <p class="text-muted">Please provide a summary of the details regarding the issue at dispute.</p>
        <textarea rows="14" :value="details" @input="$emit('update:details', $event.target.value)" autofocus></textarea>
    </div>
</template>

<script>
export default {
    props: {
        details: String,
    }
}
</script>

<style>

</style>


